<template>
  <div>
    <!--等于还是包含等关系-->
    <el-select @change="update" v-model="relationship" placeholder="相对关系">
      <el-option
        v-for="item in relationOptionss"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { getCustomerAttributeList, getBigWheelList, getMessageListForNode, getGroupList, getCustomerEventList, getWechatPublicListForNode, getWePagesListForNode } from '@/api/customer.js'
import { mapGetters } from 'vuex'
export default {
  name: '',
  props: ['relationOptions', 'value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      relationship: this.value,
      relationOptionss: this.relationOptions
    }
  },
  watch: {
    value: function (val) {
      this.relationship = val
    },
    relationOptions: function (val) {
      this.relationOptionss = val
    }
  },
  computed: {
    ...mapGetters([
      'getQuery'
    ])
  },
  methods: {
    update() {
      this.$emit('change', this.relationship)
    }
  },
  mounted() {
  },
  created() {
    this.update()
    console.log('high.relationOptions', this.relationOptions)
  }
}
</script>

<style scoped>

</style>
